<ion-content>
  <button class="close-modal small-clickable" (click)="closeModalPack()" *ngIf="modalType != 'modalConsentPush' && modalType != 'modalMaj1' && modalType != 'modalMaj2' && modalType != 'modalMaj3' && modalType != 'modalStorage2' && modalType != 'modalErrorRetry' && modalType != 'modal500' && modalType != 'modalTimeout' && modalType != 'modalCgaac'">
    <img src="assets/2022/icons/close-off.svg" alt="EnVoitureSimone" height="24">
  </button>

  <!-- DEBUG MODE -->
  <div class="modal-debug-mode content-center flex-column" *ngIf="modalType == 'debugMode'">
    <div [ngClass]="{'margin-bottom-30': !isDesktop, 'margin-bottom-40': isDesktop}">
      <img src="assets/svg/asset-support.svg" alt="EnVoitureSimone">
    </div>
    <p><b>Rapport d'erreur</b></p>
    <p>En cliquant sur "Démarrer", toutes tes actions seront enregistrées. Merci de reproduire le problème que tu as rencontré et de cliquer sur "<b>Envoyer</b>" à la fin de ton enregistrement.</p>
    <button class="btn full-width margin-v-10" (click)="launchDebugMode()">Démarrer</button>
    <button class="btn light full-width" (click)="launchCleanStorage()">Réinitialiser mes données</button>
  </div>

  <!-- DEV DEBUG MODE -->
  <!-- <div class="modal-debug-mode content-center flex-column" *ngIf="modalType == 'devDebugMode'">
    <div [ngClass]="{'margin-bottom-30': !isDesktop, 'margin-bottom-40': isDesktop}">
      <img src="assets/svg/asset-support.svg" alt="EnVoitureSimone">
    </div>
    <p><b>Saisis un ID de LOG</b></p>
    <form class="evs-form margin-bottom-20 wpe-100">
      <fieldset>
        <div>
          <input type="text" [(ngModel)]="logId" [ngModelOptions]="{standalone: true}">
        </div>
      </fieldset>
    </form>
    <button class="btn full-width" (click)="easyDebugService.transformStorageData(logId)">Récupérer</button>
  </div> -->

  <!-- CGAAC -->
  <div class="modal-cgaac content-center flex-column" *ngIf="modalType == 'modalCgaac'">
    <h2>Nous avons mis à jour nos conditions générales</h2>
    <p class="callout margin-v-40">Nos conditions générales d’aide à l’apprentissage de la conduite ont été modifiées. Tu dois les accepter pour poursuivre ton utilisation du service.</p>
    <button class="btn light white full-width margin-bottom-10" (click)="readConditions()">Lire les conditions</button>
    <button class="btn full-width" (click)="postCgaac()">Accepter</button>
  </div>

  <!-- NOTATION DE LECONS -->
  <div class="modal-notation-lessons content-center flex-column" *ngIf="modalType == 'modalNotationLessons'">
    <div [ngClass]="{'margin-bottom-30': !isDesktop, 'margin-bottom-40': isDesktop}">
      <img src="assets/svg/asset-notation.svg" alt="EnVoitureSimone">
    </div>
    <p><b>Tu as {{counter}} leçon<span *ngIf="counter > 1">s</span> à noter&nbsp;!</b></p>
    <p [ngClass]="{'margin-h-20': isDesktop}">Comment s'est passée ta dernière leçon de conduite&nbsp;?</p>
    <button class="btn full-width light" [ngClass]="{'margin-top-10': !isDesktop, 'margin-top-20': isDesktop}" (click)="closeModalPack()">Plus tard</button>
    <button class="btn full-width margin-top-8" (click)="openLink('notation')">Noter mes leçons</button>
  </div>
  
  <!-- PUSH NOTIF -->
  <div class="modal-notation-lessons content-center flex-column" *ngIf="modalType == 'modalConsentPush'">
    <div [ngClass]="{'margin-bottom-30': !isDesktop, 'margin-bottom-40': isDesktop}">
      <img src="assets/svg/push-notif.svg" alt="EnVoitureSimone">
    </div>
    <p><b>Une formation aux petits oignons</b></p>
    <p [ngClass]="{'margin-h-20': isDesktop}">Active les notifications pour avoir un suivi sur-mesure de ta formation et bénéficier de conseils pour obtenir ton permis</p>
    <button *ngIf="true" class="btn full-width light" [ngClass]="{'margin-top-10': !isDesktop, 'margin-top-20': isDesktop}" (click)="closeModalPack()">Peut-être plus tard</button>
    <button *ngIf="false" class="btn full-width light" [ngClass]="{'margin-top-10': !isDesktop, 'margin-top-20': isDesktop}" (click)="closeModalPack()">Plus tard</button>
    <button *ngIf="true" class="btn full-width margin-top-8" (click)="activatePushNotifs()">Activer les notifications</button>
    <button *ngIf="false" class="btn full-width margin-top-8" (click)="pushNotifConsentNext()">Suivant</button>
  </div>

  <!-- MARKETING NEW PACK PERMIS CONDUITE -->
  <div class="modal-pack-permis-conduite content-center flex-column" *ngIf="modalType == 'temp'">
    <div [ngClass]="{'margin-bottom-30': !isDesktop, 'margin-bottom-40': isDesktop}">
      <img src="assets/svg/asset-lecons.svg" alt="EnVoitureSimone">
    </div>
    <p><b>Prêt à prendre le volant&nbsp;?</b></p>
    <p [ngClass]="{'margin-h-20': isDesktop}">Avec le Pack Permis, réserve des leçons où tu veux et quand tu veux&nbsp;!</p>
    <button class="btn" [ngClass]="{'margin-top-10': !isDesktop, 'margin-top-20': isDesktop}" (click)="openLink('permis')">Acheter le Pack Permis</button>
  </div>

  <div class="new-modal-marketing-slider" *ngIf="modalType == 'modalPackPermis'">
    <div class="padding-h-20">
      <div class="background-lecons">
        <img src="assets/svg/asset-lecons.svg" alt="code de la route">
      </div>
      <div class="new-modal-marketing-text">
        <h1>Prêt à prendre le volant&nbsp;?</h1>
        <p>
          Avec le Pack Permis, réserve des leçons où tu veux et quand tu veux&nbsp;!
        </p>
      </div>
    </div>
    
    <div class="call-center-container" [ngClass]="{'call-center-mobile': !isPlatformDesktop}">
      <a *ngIf="!isPlatformDesktop" class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
        <div class="call-center-text-wrapper">
          <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
        </div>
      </a>
      <div *ngIf="isPlatformDesktop" class="call-center-text-wrapper">
        <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
        <div class="call-center-desc">Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span><span class="lowlight"> (appel gratuit)</span></div>
      </div>
    </div>
    
    <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
      <div class="text-container">Découvrir le Pack Permis</div>
    </div>
  </div>

  <!-- MARKETING PUB ENTRAINEMENTS -->
  <div class="modal-pub-v2 content-center flex-column" *ngIf="modalType == 'modalPubEntrainenements'">
    <div class="top-part">
      <img src="assets/svg/bgModalPub.svg" alt="En Voiture Simone">
      <div class="titles">
        <h2 class="title">
          <b class="color5">{{counter}} bonne<span *ngIf="counter > 1">s</span> réponse<span *ngIf="counter > 1">s</span>&nbsp;!</b><br>Bientôt prêt pour la <b class="color2">conduite&nbsp;?</b>
        </h2>
      </div>
      <div class="car"></div>
    </div>
    <div class="bottom-part">
      <div class="texts">
        En plus du code,<br>En Voiture Simone t'accompagne<br>pour décrocher le permis
      </div>
      <div class="buttons">
        <button class="btn light full-width margin-bottom-10" (click)="closeModalPack()">Continuer l'entraînement</button>
        <button class="btn full-width" (click)="openLink('permis')">En savoir plus</button>
      </div>
    </div>
  </div>

  <!-- MARKETING SERIE REGISTERED -->
  <div class="modal-pub-v2 content-center flex-column" *ngIf="modalType == 'modalPermisSerie'">
    <div class="top-part">
      <img src="assets/svg/bgModalPub.svg" alt="En Voiture Simone">
      <div class="titles">
        <h2 class="title" *ngIf="randomTxtSerieRegistered == 1">"Veni, <b class="color5">vidi</b>, <b class="color2">Pack Permis</b>"<br><br>Jules César</h2>
        <h2 class="title" *ngIf="randomTxtSerieRegistered == 2">En achetant <b class="color1">tout de suite</b> le <b class="color2">Pack Permis</b>, tu bénéficies de <b class="color3">nouveautés</b> aussi sur le <b class="color1">Code</b></h2>
        <h2 class="title" *ngIf="randomTxtSerieRegistered == 3">Ceci est une <b class="color4">information</b> pour te <b class="color5">rappeler</b> que nous vendons le <b class="color2">Pack Permis</b></h2>
        <h2 class="title" *ngIf="randomTxtSerieRegistered == 4">Il n'y a pas que les <b class="color5">séries</b> dans la <b class="color6">vie</b>,<br>il y a <b class="color5">aussi</b> le <b class="color2">Pack Permis</b></h2>
      </div>
      <div class="car"></div>
    </div>
    <div class="bottom-part">
      <div class="texts callout">
        <b>Envie de passer le permis&nbsp;?</b>Pense au Pack Permis.<br>{{packPermisPrice}}€ seulement
      </div>
      <div class="buttons">
        <button class="btn light white full-width margin-bottom-10" (click)="closeModalPack()">Plus tard</button>
        <button class="btn full-width" (click)="openLink('permis')">En savoir plus</button>
      </div>
    </div>
  </div>
  
  <!-- MODAL Timeout -->
  <!-- <div class="modal-errors content-center padding-20" *ngIf="modalType == 'modalErrorRetry'">
    <h1 class="normal margin-bottom-40">🤭</h1>
    <p><b>Oups&nbsp;! Une erreur est survenue...</b></p>
    <button class="btn margin-top-20" (click)="reloadPage()">Rééssayer</button>
  </div> -->
  
  <!-- MODAL 500 -->
  <div class="modal-errors content-center padding-20" *ngIf="modalType == 'modalTimeout'">
    <div class="simone-spinner">
      <div class="wrapper simone-wrapper--animate">
        <div class="loading-circle"></div>
        <div class="simone-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100.2 81.41"><defs><style>.cls-1{fill:#779ea9;}.cls-2,.cls-5{fill:none;}.cls-3{fill:#585657;}.cls-4{fill:#f3c6b0;}.cls-5{stroke:#000;stroke-miterlimit:10;stroke-width:1.3354px;}.cls-6{fill:#ad9fa3;}</style></defs><title>logo-car-only</title><path class="cls-1" d="M99.7,56.9,79.9,47.1,75.8,8.9l-39.2-3L24.2,47.3,0,53.7,1.8,69.5l8.5-.5,89.9,1.4Zm-67-7.6,8.4-34.8,29.2,2.2L72,51.5Z" transform="translate(0 -0.09)"/><polygon class="cls-2" points="41.1 14.51 32.7 49.21 72 51.41 70.3 16.61 41.1 14.51"/><path class="cls-3" d="M58.8,74.3A7.2,7.2,0,1,0,66,67.1,7.17,7.17,0,0,0,58.8,74.3Zm3.4,0A3.8,3.8,0,1,1,66,78.1,3.8,3.8,0,0,1,62.2,74.3Z" transform="translate(0 -0.09)"/><path class="cls-3" d="M26.8,74.3A7.2,7.2,0,1,0,34,67.1,7.17,7.17,0,0,0,26.8,74.3Zm3.4,0A3.8,3.8,0,1,1,34,78.1,3.8,3.8,0,0,1,30.2,74.3Z" transform="translate(0 -0.09)"/><circle class="cls-2" cx="66" cy="74.21" r="3.8"/><circle class="cls-2" cx="34" cy="74.21" r="3.8"/><path class="cls-3" d="M94,19.8l-11.5-5a1.73,1.73,0,0,1-.9-2.2l.2-.4a1.73,1.73,0,0,1,2.2-.9l11.5,5a1.73,1.73,0,0,1,.9,2.2l-.2.4A1.73,1.73,0,0,1,94,19.8Z" transform="translate(0 -0.09)"/><path class="cls-3" d="M69.2,60.2l-.6-.2a.84.84,0,0,1-.4-1.1L86.3,17.2a.84.84,0,0,1,1.1-.4l.6.2a.84.84,0,0,1,.4,1.1L70.3,59.8A.78.78,0,0,1,69.2,60.2Z" transform="translate(0 -0.09)"/><path class="cls-4" d="M43.2,30.6,58.5,21,67,35.3s0-.3-.4,11.1a16.89,16.89,0,0,1-9.5,3.8c-5.6.4-12.4.2-13.5-.2-1.2-.2-4.5,0-3.1-5.4C40.5,44.7,41.8,30.7,43.2,30.6Z" transform="translate(0 -0.09)"/><path class="cls-5" d="M48.3,42.8s7.7,7.2,12.4,0" transform="translate(0 -0.09)"/><ellipse cx="50.4" cy="37.51" rx="1.3" ry="1.9"/><ellipse cx="57.8" cy="37.51" rx="1.3" ry="1.9"/><path class="cls-6" d="M55.8,22.8s.7,9.1-8.8,9.7c-6.3.4-5.4,7.1-5.4,7.1s-10.5-2.4-9.7-12.3S43,12.5,45.5,12.7,44,5,47.4,1.7c3.2-3.2,16-2,11.8,7.1-2.4,5.2,3.6,2.8,7.9,6.4s7.9,6.4,5.6,17.4c-1.7,8.5-5.3,7.9-5.3,7.9l1.2-5.2s-2.4,2.1-4.7,1.5C58.6,35.5,57.8,25.2,55.8,22.8Z" transform="translate(0 -0.09)"/><path class="cls-4" d="M64.2,50.5l11-10s1.4-1.7.8-1.9.5-4.6,1.8-5,2.7,1.2,2.7,1.2,1.9,2.6,1.9,3.4,1.3,2.8-3,2.5S67.7,51.8,67.7,51.8l-3.9-.4Z" transform="translate(0 -0.09)"/></svg>
        </div>
      </div>
    </div>
    <p><b>Hmm, quelque chose semble prendre plus longtemps que prévu…<br>Merci de patienter</b></p>
  </div>

  <!-- MODAL STORAGE 1 -->
  <div class="modal-storage content-center padding-20" *ngIf="modalType == 'modalStorage1' || modalType == 'modalStorage2' || modalType == 'modalStorage3'">
    <div class="big-emojis margin-bottom-40">
      <img src="assets/png/anxious-face-with-sweat.png" alt="EnVoitureSimone">
      <!-- 😰 -->
    </div>
    <h3><b>Plus de place&nbsp;!</b></h3>
    <p>Oups&nbsp;! Tu n'as plus assez d'espace sur ton appareil et certaines fonctionnalités ont été bloquées.</p>
    <p *ngIf="modalType == 'modalStorage1'">Une fois le ménage fait dans ton stockage (au moins 25Mo), clique sur le bouton pour redémarrer ton application&nbsp;!</p>
    <p *ngIf="modalType == 'modalStorage2' || modalType == 'modalStorage3'">Fait de la place (au moins 25Mo), pour débloquer tes fonctionnalités</p>
    <button *ngIf="modalType == 'modalStorage1'" class="btn margin-top-20" (click)="goToCheckDiskSpace1()">J'ai fait de la place</button>
    <button *ngIf="modalType == 'modalStorage2'" class="btn margin-top-20" (click)="goToCheckDiskSpace2()">Compris</button>
    <button *ngIf="modalType == 'modalStorage3'" class="btn margin-top-20" (click)="closeModalPack()">Compris</button>
    <!-- <button *ngIf="modalType == 'modalStrage1'" class="btn margin-top-20" (click)="goToCheckDiskSpace1()">J'ai fait de la place
      <div class="broom">
        <img src="assets/png/broom.png" alt="broom">
      </div>
    </button> -->
  </div>

  <!-- MODAL STORAGE 4 -->
  <div class="modal-storage content-center padding-20" *ngIf="modalType == 'modalStorage4'">
    <div class="big-emojis margin-bottom-40">
      <img src="assets/png/anxious-face-with-sweat.png" alt="EnVoitureSimone">
      <!-- 😰 -->
    </div>
    <h3><b>Plus de place&nbsp;!</b></h3>
    <p>Il semblerait que tu n'aies pas assez d'espace disque disponible pour télécharger la dernière version.</p>
    <p>Libère au moins 25 Mo sur ton appareil avant de réessayer.</p>
    <button *ngIf="modalType == 'modalStorage1'" class="btn margin-top-20" (click)="reloadApp()">Réessayer</button>
    <!--  <div class="broom">
        <img src="assets/png/broom.png" alt="broom">
      </div> -->
  </div>

  <!-- MODAL OFFLINE -->
  <div class="modal-offline content-center padding-20" *ngIf="modalType == 'modalOffline'">
    <h1 class="margin-bottom-40">🙈</h1>
    <h3><b>Connexion internet perdue</b></h3>
    <p>Le téléchargement de la mise à jour a été interrompu.</p>
    <p>Vérifie ta connexion internet avant de réessayer.</p>
    <button class="btn margin-top-20" (click)="reloadApp()">Réessayer</button>
    <!--  <div class="broom">
        <img src="assets/png/broom.png" alt="broom">
      </div> -->
  </div>

  <!-- MODAL MAJ 1 -->
  <div class="modal-maj content-center padding-20" *ngIf="modalType == 'modalMaj1'">
    <p><b>Nouvelle version disponible</b></p>
    <p>Il semblerait que ton application ne soit pas à jour. Clique ici pour bénéficier de la dernière version existante.</p>
    <button class="btn margin-top-20" (click)="updateApp()">Mettre à jour</button>
  </div>

    <!-- MODAL MAJ 2 -->
    <div class="modal-maj content-center padding-20" *ngIf="modalType == 'modalMaj2'">
      <p><b>Téléchargement en cours...</b></p>
      <p>Merci de ne pas fermer ton application pendant la durée du téléchargement.</p>
      <loader-bar-comp class="wpe-100" [compOptions]="{percent: dlProgress, hasBorder: true}"></loader-bar-comp>
      <p><b>{{dlProgress}} %</b></p>
    </div>

    <!-- MODAL MAJ 3 -->
    <div class="modal-maj content-center padding-20" *ngIf="modalType == 'modalMaj3'">
      <ion-spinner class="customSpinner margin-top-10" name="crescent"></ion-spinner>
      <p><b>Mise à jour terminée&nbsp;!</b></p>
      <p>Ton application va automatiquement redémarrer dans 3 secondes...</p>
    </div>

  <!-- MODAL 500 -->
  <div class="modal-errors content-center padding-20" *ngIf="modalType == 'modal500'">
    <div class="big-emojis margin-bottom-40">
      <img src="assets/png/face-with-head-bandage.png" alt="EnVoitureSimone">
      <!-- 🤕 -->
    </div>
    <p><b>Nous ne sommes pas parvenus à récupérer tes données...</b></p>
    <button class="btn margin-top-20" (click)="goToAccueil()">Retour à l'accueil</button>
  </div>

  <!-- MODAL IMPAYES -->
  <div class="modal-impayes content-center padding-20" *ngIf="modalType == 'modalImpayes'">
    <div class="content">
      <div class="big-emojis margin-bottom-40">
        <img src="assets/png/speak-no-evil-monkey.png" alt="EnVoitureSimone">
        <!-- 🙊 -->
      </div>
      <h3><b>Tu es en impayé</b></h3>
      <p>Il semblerait que nous ayons un problème avec l’échéance de l’un de tes paiements.</p>
      <p>Nous avons bloqué ton accès à certaines fonctionnalités. Régularise ta situation pour y accéder de nouveau.</p>
      <button class="btn light white wpe-100  margin-top-20" (click)="openLink('zendesk')">Contacter le service client</button>
      <button class="btn wpe-100 margin-top-10" (click)="goToRegulariser()">Régulariser ma situation</button>
    </div>
  </div>

  <!-- MARKETING ACHATS -->
  <div class="modal-achats text-left align-left" *ngIf="modalType == 'modalAchats'">

    <h3 class="margin-bottom-40">À quoi correspondent mes crédits ?</h3>
    
    <h4>EXAMEN DU CODE</h4>
    <p>Tu devras t'acquitter d'une somme fixe de 30€ qui sera reversée directement à la Poste pour l'organisation de ton examen du code de la route.</p>
    <h4>HEURES DE CONDUITE</h4>
    <p>Tu dépenses tes heures lors des leçons de conduite que tu effectues avec nos moniteurs.<br>Ces heures de conduite serviront également pour ton examen de la conduite.</p>
  </div>

  <!-- SERIES GUEST -->
  <div class="marketing-register-modal" *ngIf="modalType == 'modalSeriesGuest'">
    <div class="evs-logo" [ngClass]="{'animated fadeIn': (!isCordova && isDesktop)}">
      <img src="assets/img/logo-inline.svg" alt="En Voiture Simone">
    </div>

    <h3 class="margin-bottom-40">Connecte-toi gratuitement pour continuer et accéder à 100% des questions.</h3>

    <button class="btn light white full-width margin-bottom-10" (click)="openLink('login/signIn')">Me connecter</button>
    <button class="btn full-width" (click)="openLink('login/register')">Créer un compte gratuit</button>
  </div>

  <!-- MARKETING REGISTER -->
  <div class="marketing-register-modal" *ngIf="modalType == 'marketingRegister'">
    <div class="evs-logo" [ngClass]="{'animated fadeIn': (!isCordova && isDesktop)}">
      <img src="assets/img/logo-inline.svg" alt="En Voiture Simone">
    </div>

    <h3 class="margin-bottom-40">Crée ton compte pour profiter gratuitement de cette fonctionnalité.</h3>

    <button class="btn light white full-width margin-bottom-10" (click)="openLink('login/signIn')">Me connecter</button>
    <button class="btn full-width" (click)="openLink('login/register')">Créer un compte gratuit</button>
  </div>

  <!-- MARKETING REGULAR -->
  <div class="new-modal-marketing-slider" *ngIf="modalType == 'marketingRegular'">
    <div class="padding-h-20">
      <div class="background-avis">
        <img src="assets/svg/asset-avis.svg" alt="code de la route">
      </div>
      <div class="new-modal-marketing-text">
        <h1>Passe la seconde</h1>
        <p>
          Cette fonctionnalité est réservée aux élèves ayant souscrit au Pack Permis
        </p>
      </div>
    </div>
    
    <div class="call-center-container" [ngClass]="{'call-center-mobile': !isPlatformDesktop}">
      <a *ngIf="!isPlatformDesktop" class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
        <div class="call-center-text-wrapper">
          <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
        </div>
      </a>
      <div *ngIf="isPlatformDesktop" class="call-center-text-wrapper">
        <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
        <div class="call-center-desc">Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span><span class="lowlight"> (appel gratuit)</span></div>
      </div>
    </div>
    
    <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
      <div class="text-container">Découvrir le Pack Permis</div>
    </div>
  </div>

  <!-- MARKETING REGULAR LIVRET CDR -->
  <div class="new-modal-marketing-slider" *ngIf="modalType == 'marketingRegularLivretCDR'">
    <div class="padding-h-20">
      <div class="background-avis">
        <img src="assets/svg/asset-avis.svg" alt="code de la route">
      </div>
      <div class="new-modal-marketing-text">
        <h1>Passe la seconde</h1>
        <p>
          Achète le Pack Permis, et reçois gratuitement notre livre de code.<br/>240 pages de bonheur qui se lisent aussi bien qu'Harry Potter.
        </p>
      </div>
    </div>
    
    <div class="call-center-container" [ngClass]="{'call-center-mobile': !isPlatformDesktop}">
      <a *ngIf="!isPlatformDesktop" class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
        <div class="call-center-text-wrapper">
          <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
        </div>
      </a>
      <div *ngIf="isPlatformDesktop" class="call-center-text-wrapper">
        <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
        <div class="call-center-desc">Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span><span class="lowlight"> (appel gratuit)</span></div>
      </div>
    </div>
    
    <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
      <div class="text-container">Découvrir le Pack Permis</div>
    </div>
  </div>

  <!-- MARKETING REGULAR 1H OFFRES-->
  <div class="new-modal-marketing-slider" *ngIf="modalType == 'marketingRegularOneHourOffres'">
    <div class="padding-h-20">
      <div class="background-avis">
        <img src="assets/svg/asset-avis.svg" alt="code de la route">
      </div>
      <div class="new-modal-marketing-text">
        <h1>Passe la seconde</h1>
        <p>
          Cette fonctionnalité est réservée aux élèves ayant souscrit à au moins 1 heure de conduite.
        </p>
      </div>
    </div>
    
    <div class="btn-new-modal-marketing btn content-center" (click)="openLink('offres')">
      <div class="text-container">Découvrir toutes nos offres</div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
      <!-- <img class="block-right margin-right-5" src="assets/svg/arrowRightWhite.svg" alt="EnVoitureSimone" height="20"> -->
    </div>
  </div>

  <!-- OLD MARKETING REGULAR -->
  <div class="marketing-regular-modal" *ngIf="modalType == 'oldMarketingRegular'">
    <h3>Passe la seconde</h3>
    <p>Retrouve cette fonctionnalité dans notre formule Code Simone</p>
    <div class="evs-card margin-v-20" (click)="openLink('code-de-la-route')">
      <div class="text-container">
        <div class="callout uppercase bold">CODE SIMONE</div>
        <div class="text-gray-shade margin-top-5">Séries personnalisées, experts à ton écoute, mode hors connexion, et bien plus encore.</div>
        <div class="price margin-top-10">
          <span class="margin-right-10"><b>{{codeSimonePrice}}€</b></span>
        </div>
      </div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5 text-gray-74"></i>
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20"> -->
    </div>
    <div class="evs-card margin-bottom-40" (click)="openLink('permis')">
      <div class="border-left-highlight"></div>
      <div class="text-container">
        <div class="callout uppercase bold">Offert avec le Pack Permis</div>
      </div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5 text-gray-74"></i> -->
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20">
    </div>
  </div>

  <!-- MARKETING ZENDESK -->
  <div class="new-modal-marketing-slider" *ngIf="modalType == 'marketingZendesk'">
    <div class="padding-h-20">
      <div class="background-support">
        <img src="assets/svg/asset-support.svg" alt="code de la route">
      </div>
      <div class="new-modal-marketing-text">
        <h1>Passe la seconde</h1>
        <p>Avec notre formule Pack Permis, un expert répond à toutes tes questions</p>
      </div>
    </div>
    
    <div class="call-center-container" [ngClass]="{'call-center-mobile': !isPlatformDesktop}">
      <a *ngIf="!isPlatformDesktop" class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
        <div class="call-center-text-wrapper">
          <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
        </div>
      </a>
      <div *ngIf="isPlatformDesktop" class="call-center-text-wrapper">
        <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
        <div class="call-center-desc">Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span><span class="lowlight"> (appel gratuit)</span></div>
      </div>
    </div>
    
    <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
      <div class="text-container">Découvrir le Pack Permis</div>
    </div>
  </div>

  <!-- OLD MARKETING ZENDESK -->
  <div class="marketing-zendesk-modal" *ngIf="modalType == 'oldMarketingZendesk'">
    <h3>Passe la seconde</h3>
    <p>Avec la formule Code Simone, un expert répond à toutes tes questions.</p>
    <div class="evs-card margin-v-20" (click)="openLink('code-de-la-route')">
      <div class="text-container">
        <div class="callout uppercase bold">CODE SIMONE</div>
        <div class="text-gray-shade margin-top-5">Séries personnalisées, experts à ton écoute, mode hors connexion, et bien plus encore.</div>
        <div class="price margin-top-10">
          <span class="margin-right-10"><b>{{codeSimonePrice}}€</b></span>
        </div>
      </div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20">
    </div>
    <div class="evs-card margin-bottom-40" (click)="openLink('permis')">
      <div class="border-left-highlight"></div>
      <div class="text-container">
        <div class="callout uppercase bold">Offert avec le Pack Permis</div>
      </div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20">
    </div>
  </div>
  
  <!-- MARKETING EXAM CODE -->
  <div class="marketing-exam-modal" *ngIf="modalType == 'marketingExamCode'">
    <h3>Passe la seconde</h3>
    <p>Réserve directement ta date d'examen dans ton compte En Voiture Simone.</p>
    <p class="small-text">Attention. La formule n'inclut le pas le coût d'inscription de 30€ pour chaque examen (tarif réglementé).</p>
    <!-- <p class="small-text">Attention. La formule n'inclut le pas le coût d'inscription de 30€ pour chaque examen (tarif réglementé).<br><a class="underline clickable" (click)="openLink('aideExamen')">Tout savoir sur l'examen du code</a></p> -->
    <div class="evs-card margin-v-20" (click)="openLink('permis')">
      <div class="text-container">
        <div class="callout uppercase bold">CODE SIMONE</div>
        <div class="text-gray-shade margin-top-5">Séries personnalisées, experts à ton écoute, mode hors connexion, et bien plus encore.</div>
        <div class="price margin-top-10">
          <span class="margin-right-10"><b>29€</b></span>
        </div>
      </div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20">
    </div>
    <div class="evs-card margin-bottom-40" (click)="openLink('permis')">
      <div class="border-left-highlight"></div>
      <div class="text-container">
        <div class="callout uppercase bold">Offert avec le Pack Permis</div>
      </div>
      <!-- <i class="icon ion-ios-arrow-forward block-right margin-right-5"></i> -->
      <img class="block-right margin-right-5" src="assets/svg/arrowRight.svg" alt="EnVoitureSimone" height="20">
    </div>
  </div>

  <!-- MARKETING EXAM CODUITE -->
  <div class="new-modal-marketing-slider" *ngIf="modalType == 'marketingExamConduite'">
    <div class="padding-h-20">
      <div class="background-conduite">
        <img src="assets/svg/asset-conduite.svg" alt="code de la route">
      </div>
      <div class="new-modal-marketing-text">
        <h1>Passe la seconde</h1>
        <p>Pour réserver un accompagnement à l'examen de la conduite, tu dois avoir acheté au moins 20 leçons de conduite, ou le Pack Permis</p>
      </div>
    </div>
    
    <div class="call-center-container" [ngClass]="{'call-center-mobile': !isPlatformDesktop}">
      <a *ngIf="!isPlatformDesktop" class="call-center-link" [href]="'tel:' + callCenterPhoneFormatted">
        <div class="call-center-text-wrapper">
          <button class="btn light margin-bottom-8">Appelle-nous, c'est gratuit&nbsp;!</button>
        </div>
      </a>
      <div *ngIf="isPlatformDesktop" class="call-center-text-wrapper">
        <div class="call-center-title">Des questions sur le Pack Permis&nbsp;?</div>
        <div class="call-center-desc">Appelle le <span class="highlight-orange">{{ callCenterPhone }}</span><span class="lowlight"> (appel gratuit)</span></div>
      </div>
    </div>
    
    <div class="btn-new-modal-marketing btn content-center" (click)="openLink('permis')">
      <div class="text-container">Découvrir le Pack Permis</div>
    </div>
  </div>

  <!-- REGISTERED -->
  <div class="registered-modal" *ngIf="modalType == 'registered'">
    <img src="{{imgRegisteredPath}}" alt="Registered please !">
    <h3>Poursuivre l'entraînement</h3>
    <p>Tu souhaites réaliser de nouvelles séries&nbsp;? Crée gratuitement ton compte et profite de 2 séries supplémentaires&nbsp;!</p>
    <button class="btn margin-top-20" (click)="openLink('login')">Je crée mon compte</button>
  </div>

  <!-- PREMIUM -->
  <div *ngIf="modalType == 'premium'" class="premium-modal">
    <table class="modal-premium-title">
      <tr>
        <td><h3>Deviens élève pour un accès illimité&nbsp;!</h3></td>
        <td><img class="modal-premium-visuel" src="{{imgPremiumPath}}" alt="C'est parti"></td>
      </tr>
    </table>
    <div class="modal-premium-offers">
      <div class="modal-premium-offer" [ngClass]="{'active-offer': (activeOffer == 'code')}" (mouseover)="activeOffer = 'code'" (click)="activeOffer = 'code'">
        <div class="content">
          Formule code
          <ng-container *ngFor="let offer of offers">
            <span *ngIf="offer.offer_type === 'code'" class="price"><b>{{offer.amount}}€</b></span>
          </ng-container>
        </div>
      </div>
      <div class="modal-premium-offer" [ngClass]="{'active-offer': (activeOffer == 'heures')}" (mouseover)="activeOffer = 'heures'" (click)="activeOffer = 'heures'">
        <div class="content">
          Heures de conduite
          <ng-container *ngFor="let offer of offers">
            <span *ngIf="offer.offer_type === 'hour' && offer.min_quantity == 1" class="price"><b>{{offer.amount}}€</b></span>
          </ng-container>
        </div>
      </div>
      <div class="modal-premium-offer" [ngClass]="{'active-offer': (activeOffer == 'permis')}" (mouseover)="activeOffer = 'permis'" (click)="activeOffer = 'permis'">
        <div class="content">
          <div *ngIf="isPromo" class="bandeau-promo">PROMO</div>
          Pack permis
          <ng-container *ngFor="let offer of offers">
            <span *ngIf="isPromo && offer.offer_type === 'big_pack'" class="price"><b>{{offer.amount - offer.discount}}€</b></span>
            <span *ngIf="!isPromo && offer.offer_type === 'big_pack'" class="price"><b>{{offer.amount}}€</b></span>
            <del *ngIf="isPromo && offer.offer_type === 'big_pack'" class="old-price"><b>{{offer.amount}}€</b></del>
          </ng-container>
        </div>
      </div>
    </div>
    <ng-container *ngIf="activeOffer == 'code'">
      <div class="modal-premium-offer-details">
        <ul>
          <li>Entraîne-toi à <strong>1600 questions</strong> conformes à l’examen 2019</li>
          <li>Accède à plus de <strong>140 leçons</strong> réparties en <strong>11 thématiques</strong> de cours</li>
          <li>Avance à <strong>ton rythme</strong> et suis tes progrès jour après jour</li>
          <li>Réserve ta place à l’examen du code <strong>quand tu le souhaites</strong> auprès de l’un de nos centres partenaires La Poste</li>
        </ul>
      </div>
      <button class="btn full-width margin-v-20" (click)="openLink('code-de-la-route')">Je passe le code</button>
    </ng-container>
    <ng-container *ngIf="activeOffer == 'heures'">
      <div class="modal-premium-offer-details">
        <ul>
          <li>Réserve tes leçons de conduite en ligne avec nos <strong>enseignants diplômés</strong></li>
          <li>Organise ta formation <strong>près de chez toi</strong>, aux créneaux qui t'arrangent, <strong>7j/7</strong> de <strong>7h à 23h</strong></li>
          <li>Avance à <strong>ton rythme</strong> et réserve tes heures <strong>sans engagement</strong></li>
          <li>Conserve <strong>le même enseignant</strong> tout au long de ta formation, ou change-en <strong>quand tu le souhaites</strong></li>
        </ul>
      </div>
      <button class="btn full-width margin-v-20" (click)="openLink('permis')">Je réserve des heures</button>
    </ng-container>
    <ng-container *ngIf="activeOffer == 'permis'">
      <div class="modal-premium-offer-details">
        <ul>
          <li>Entraîne-toi à <strong>1600 questions</strong> conformes à l’examen 2019</li>
          <li>Réserve ta place à l’examen du code <strong>quand tu le souhaites</strong></li>
          <li>Une fois le code en poche, réserve tes leçons de conduite en ligne avec nos <strong>enseignants diplômé</strong>s</li>
          <li>Organise ta formation <strong>près de chez toi</strong>, aux créneaux qui <strong>t'arrangent</strong>, 7j/7 de 7h à 23h</li>
          </ul>
        </div>
        <button class="btn full-width margin-v-20" (click)="openLink('permis')">Je passe le permis <span class='padding-left-10'>🚀</span></button>
    </ng-container>
  </div>

  <!-- DRIVING PACK -->
  <div class="driving-modal" *ngIf="modalType == 'drivingPack'">
    <img src="{{imgDrivingPath}}" alt="En Voiture !">
    <h3>La conduite avec <br> En Voiture Simone</h3>
    <p>
      En Voiture Simone est <strong>disponible partout</strong> en France pour le <strong>code de la route</strong>, et à <strong>Paris</strong>, <strong>Bordeaux</strong>, <strong>Lyon</strong>, <strong>Lille</strong>, <strong>Toulouse</strong> et <strong>Montpellier</strong> pour les <strong>leçons de conduite</strong>&nbsp;!
    </p>
    <p>Prépare l'examen du permis de conduire avec En Voiture Simone :</p>
    <ul class="margin-0">
      <li><strong>Gère</strong> ton emploi du temps comme tu l'entends en réservant tes leçons de conduite
      <strong>7j/7</strong> de <strong>7h</strong> à <strong>23h</strong></li>
      <li>Apprends à conduire auprès de nos enseignants <strong>diplômés</strong></li>
      <li>Démarre en bas de chez toi dans l'un de nos <strong>2000 points de rendez-vous</strong></li>
    </ul>
    <button class="btn margin-v-20" (click)="openLink('permis')">Je m'inscris</button>
  </div>

  <!-- Hour only -->
  <div class="hour-modal" *ngIf="modalType == 'hourOnly'">
    <img class="img-modal-driving" src="{{imgHourOnlyPath}}" alt="En Voiture !">
    <h3>Envie de reprendre l'entraînement au code&nbsp;?</h3>
    <p>
      En Voiture Simone t'accompagne dans ta formation au code de la route pour être parfaitement préparé<span *ngIf="student?.gender == 'f'">e</span> lorsque tu prends le volant&nbsp;!
    </p>
    <button class="btn" (click)="openLink('code')">Je révise le code</button>
  </div>
</ion-content>
